import * as React from 'react';
import cn from 'classnames';

import { Step as StepType, Steps, StepVariant } from '../types';
import Step from './Step/Step';
import { useTheme } from '../../../theme';
import { useAvailableSteps } from '../hooks';
import Money from '../../../Money';
import { Money as MoneyType } from '../../../types';
import { capitalizeFirstLetter } from '../../../utils';
import { CdnIcon } from '@shared/ui';
import { STEP_ICON_NAME_BY_TYPE } from '../Icons';

export interface Props {
	className?: string;
	steps?: Steps;
	activeStep?: StepType;
	onCartClick?: () => void;
	totalPrice?: MoneyType;
	additional?: React.ReactNode;
	content?: React.ReactNode;
	renderAdditionalStep?: React.FunctionComponentFactory<void>;
	variant?: StepVariant;
}

const Stepbar: React.FunctionComponent<Props> = ({
	steps,
	activeStep,
	onCartClick,
	totalPrice,
	additional,
	content,
	renderAdditionalStep,
	className,
	variant = 'default'
}) => {
	const { Stepbar: css } = useTheme('Stepbar');

	const { availableSteps, currentAvailableStepIndex } = useAvailableSteps(steps, activeStep);

	const stepsArray: StepType[] = [];
	for (const key in availableSteps) {
		if (availableSteps.hasOwnProperty(key)) {
			stepsArray.push({
				...availableSteps[key],
				icon: <CdnIcon icon={STEP_ICON_NAME_BY_TYPE[capitalizeFirstLetter(key)]} />
			});
		}
	}

	return (
		<div className={cn(className, css.stepbar)}>
			<div className={css.inner}>
				<div className={css.content}>
					{additional}

					{content ?? (
						<>
							{stepsArray
								.filter(step => !step.isHidden)
								.map((step, index) => (
									<Step
										key={index}
										id={index + 1}
										step={step}
										data-step={step.type}
										isPassed={index < currentAvailableStepIndex}
										isActive={index === currentAvailableStepIndex}
										isDisabled={step.isDisabled}
										variant={variant}
									/>
								))}

							{renderAdditionalStep && renderAdditionalStep()}
						</>
					)}
				</div>

				{onCartClick && (
					<div onClick={onCartClick} className={css.cart}>
						<CdnIcon icon="Navigation/Shopping Cart" />

						<Money money={totalPrice} />

						<CdnIcon icon="Arrow/Chevron_right" />
					</div>
				)}
			</div>
		</div>
	);
};

export default Stepbar;
